export default [{"url":"https://emeka-0.api.invexerp.io","name":"Branch 1","port":"5022","isStore":true,"isHQ":true}]